import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { forwardRef } from 'react';

const ListItem = forwardRef(function ListItem(_a, ref) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsx(Item, Object.assign({ ref: ref }, props, { children: children })));
});
const Item = styled("li")(({ theme }) => (Object.assign(Object.assign({ display: "flex", alignItems: "center", borderRadius: 2, height: 36, margin: theme.spacing(0, 1), padding: theme.spacing(1, 0.5, 1, 1.25) }, theme.typography.small), { color: theme.palette.text.high, cursor: "pointer", "&:hover, &[aria-selected='true']": {
        // https://supercharged.atlassian.net/browse/MP-1611
        backgroundColor: "rgba(27, 99, 207, 0.05)",
    }, "&:active": {
        // https://supercharged.atlassian.net/browse/MP-1611
        backgroundColor: "rgba(27, 99, 207, 0.1)",
    }, "& > a": {
        "&:hover": {
            backgroundColor: "transparent",
        },
    } })));

export { ListItem };
//# sourceMappingURL=ListItem.js.map
